// TEMPORARY, to be removed when we want to release soils
import { apiRootURL } from './keys';

const shouldHideSoils = apiRootURL === 'https://api.long103.io';

export default shouldHideSoils;
